import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Device',
  path: '/homenet/device',
  redirect: '/homenet/device/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      name: 'HomeNet Device List',
      path: 'list',
      meta: {
        label: 'Device List'
      },
      component: lazyLoading('homenet/DeviceList')
    },
    {
      name: 'HomeNet Device Query',
      path: 'querytype',
      meta: {
        label: 'Device Query'
      },
      component: lazyLoading('homenet/DeviceQuery')
    },
    {
      name: 'HomeNet Device Callback',
      path: 'callback',
      meta: {
        label: 'Device Callback'
      },
      component: lazyLoading('homenet/DeviceCallbackList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/device.js